export default [{
    id: 1,
    number: 'one',
    title: 'PRELUDE AND OUTER SPACE',
    text: "<p>After months of planning and hard work, our DIY ship has finally left the surface of Earth. Looking for the Signal we're heading towards the nearest <a href='https://en.wikipedia.org/wiki/Starlink' target='_blank'>Starlink</a> relay, trying desperately to stay undetected from radars and hostiles.</p>"
    + "<p>Using Rayleigh’s hacking skills, our crew plans to repurpose the satellite for our own communications, re-sampling alien emissions and transmitting them towards what we once called Home. At bay, we dream of weakening the wall of propaganda super powers imposed on the human race and help our fellow guerilleros still trapped in evil simulations. </p>"
    + "<p>Now in orbit around our home planet, or what's left of it, we, the first crew members of the Kizi404, composed the melodies reminiscent of the cosmic journey started in our space-travelling drum machine. Hereby we drop our first message to the people of here and elsewhere. </p>"
    + "<p>If you are reading this, it means you've managed to get your hands on one of the orbital care packages we dropped on Earth. Make good use of it and share the sound. No human needs to be standardized. And remember, resist the constant brainwash of big corp led super-powers. This is an everyday effort, one day we will prevail.  </p>"
    + "<p>We, the 404s, jam the sonic waves and encrypt our communications. Well done on finding a way to get through to us. We’re glad. Now keep a low profile and stay tuned until we can reveal the next encryption key, letting you know what future beholds.</p>",
    planet: "planet_one.png",
    tracks: [{
        id: 1,
        name: 'A1: Initial Singularity',
        member: 'Roll le barge',
        link: "https://drive.google.com/drive/folders/1p4fnv-GxP0K7zVRqK50eESp1KgM4IyET?usp=sharing",
        text: ""
    }, {
        id: 2,
        name: 'A2: La fête est finie',
        member: 'Wearamask',
        link: "https://drive.google.com/drive/folders/12p3tJqCzfh9Nr_GdWlCHvDxuTmwvLmd-?usp=sharing",
        text: ""
    }, {
        id: 3,
        name: 'B1: Bending Gravity',
        member: 'Sugar "Rayleigh" Robinson',
        link: "https://drive.google.com/drive/folders/1aOZOw6FAeM2dJF2W9ON_19EKzkHjTmy3?usp=sharing",
        text: ""
    }, {
        id: 4,
        name: 'B2: Founding Fader',
        member: 'Parazar',
        link: "https://drive.google.com/drive/folders/1jZRNyBbbWjXzhbZDJ1Vi0v4QDhlesHqG?usp=sharing",
        text: ""
    }]
}]